// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d2bbdc2] .el-menu-item,[data-v-2d2bbdc2] .el-submenu__title {\n  position: relative;\n}\n.menu-red-dot[data-v-2d2bbdc2] {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  background: #ff4446;\n  border-radius: 50%;\n}\n.menu-red-dot--icon[data-v-2d2bbdc2] {\n  left: 66px;\n  top: 14px;\n}\n.menu-red-dot--inline[data-v-2d2bbdc2] {\n  left: 62px;\n  top: 50%;\n  transform: translateY(-50%);\n}", ""]);
// Exports
module.exports = exports;
